import { SupportAdminCheckContainer } from "../../containers/SupportSystem/Admin/SupportAdminCheckContainer";
export function SupportAdminCheckPage () {
    return(
       <SupportAdminCheckContainer/>
    )
}